import * as qs from "qs";

const goToAuth = function( registration: any = false, afterSign: any = null ) {
    const _loginRedirect = window['CONFIG'].routes['login'];
    const _registerRedirect = window['CONFIG'].routes['register'];
    self.location.href = (registration ? _registerRedirect : _loginRedirect) + (afterSign ? `?afterSign=${afterSign}` : "");
}

const goToRicarica = function( afterPayment: any = null ) {
    const _ricaricaRedirect = window['CONFIG'].routes['profile.ecommerce.crediti.index'] + (afterPayment ? `?afterPayment=${afterPayment}` : "");
    self.location.href = _ricaricaRedirect;
}

const redirect = function( url ) {
    self.location.href = url;
}

const reload = function() {
    self.location.reload();
}

const currentURL = function() {
    return self.location.href;
}

const route = function(name, args?) {
    let url = window['CONFIG'].routes[name];
    if (!args) return url;
    // substitute placeholder (example: {docente})
    Object.keys(args).forEach( k => {
        const v = args[k];
        if (url.indexOf(`{${k}}`) !== -1) {
            url = url.replace(`{${k}}`, v);
            delete args[k];
        }
    });
    const query = qs.stringify(args);
    return url + ((url.indexOf('?') === -1) ? '?' : '&') + query;
}

const routeApi = function(name, args?) {
    return route(`api.${name}`, args).replace("api/", '');
}

export {
    goToAuth,
    goToRicarica,
    reload,
    redirect,
    currentURL,
    route,
    routeApi,
};


// WEBPACK FOOTER //
// ./src/services/browser.ts